import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Evaluation/AlternativesSurveys/Domain/commands-core';
import { CriterionToAttributeMap } from '@Evaluation/AlternativesSurveys/types';
import { Component } from 'vue-facing-decorator';

@Component
export default class ScoringCommands extends VueCqrs {

	invokeExcludeScoringPanelistCommandV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const cmd = new c.ExcludeScoringPanelistCommandV1(workspaceId, surveyId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}

	invokeIncludeScoringPanelistCommandV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const cmd = new c.IncludeScoringPanelistCommandV1(workspaceId, surveyId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}

	invokeChangeScoringPanelistVoteStrengthCommandV1(workspaceId: number, surveyId: number, projectUserId: number, oldVoteStrength: number, newVoteStrength: number)
	{
		const cmd = new c.ChangeScoringPanelistVoteStrengthCommandV1(workspaceId, surveyId, projectUserId, oldVoteStrength, newVoteStrength);
		this.$command(cmd, projectUserId.toString());
	}

	invokeSendEmailCommandV1(workspaceId: number, surveyId: number, projectUsersIds: number[], emailSubject: string, emailBody: string)
	{
		const cmd = new c.SendEmailCommandV1(workspaceId, surveyId, projectUsersIds, emailSubject, emailBody);
		this.$command(cmd, surveyId.toString());
	}

	invokeExportSurveyScoresToAttributesCommandV1(userId: number, workspaceId: number, projectId: number, evalModelId: number, surveyId: number, mappings: CriterionToAttributeMap[])
	{
		const cmd = new c.ExportSurveyScoresToAttributesCommandV1(userId, workspaceId, projectId, evalModelId, surveyId, mappings);
		this.$command(cmd, surveyId.toString());
	}

	invokeDeleteSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.DeleteSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeCreateSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string)
	{
		const cmd = new c.CreateSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId, name, description);
		this.$command(cmd, name);
	}

	invokeUpdateSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string)
	{
		const cmd = new c.UpdateSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId, name, description);
		this.$command(cmd, surveyId.toString());
	}


	invokeIncludeSubSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		const cmd = new c.IncludeSubSurveyCommandV1(workspaceId, projectId, evalModelId, masterSurveyId, subSurveyId, voteStrength);
		this.$command(cmd, subSurveyId.toString());
	}

	invokeChangeSubSurveyVoteStrengthCommandV1(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		const cmd = new c.ChangeSubSurveyVoteStrengthCommandV1(workspaceId, projectId, evalModelId, masterSurveyId, subSurveyId, voteStrength);
		this.$command(cmd, subSurveyId.toString());
	}

	invokeExcludeSubSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number)
	{
		const cmd = new c.ExcludeSubSurveyCommandV1(workspaceId, projectId, evalModelId, masterSurveyId, subSurveyId);
		this.$command(cmd, subSurveyId.toString());
	}


	invokeStartSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.StartSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeStopSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.StopSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeUpdateSurveyCriteriaCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, criteriaIds: number[])
	{
		const cmd = new c.UpdateSurveyCriteriaCommandV1(workspaceId, projectId, evalModelId, surveyId, criteriaIds);
		this.$command(cmd, surveyId.toString());
	}

	invokeUpdateSurveyAlternativesCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, alternativeIds: number[], descriptionTemplate: string)
	{
		const cmd = new c.UpdateSurveyAlternativesCommandV1(workspaceId, projectId, evalModelId, surveyId, alternativeIds, descriptionTemplate);
		this.$command(cmd, surveyId.toString());
	}

	invokeExportAllScoringVotesToXlsCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.ExportAllScoringVotesToXlsCommandV1(workspaceId, projectId, evalModelId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeExportPanelistVotesToXlsCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
	{
		const cmd = new c.ExportPanelistVotesToXlsCommandV1(workspaceId, projectId, evalModelId, surveyId, projectUserId);
		this.$command(cmd, surveyId.toString());
	}


	invokeSavePanelistVotesCommandV1(workspaceId: number, evalModelId: number, surveyId: number, projectUserId: number, votes: any[], correlationId: string)
	{
		const cmd = new c.SavePanelistVotesCommandV1(workspaceId, evalModelId, surveyId, projectUserId, votes);
		this.$command(cmd, correlationId);
	}


	invokeSavePanelistVoteCommandV1(workspaceId: number, surveyId: number, projectUserId: number, questionId: number, voteValue: number | null, voteComment: string | null)
	{
		const cmd = new c.SavePanelistVoteCommandV1(workspaceId, surveyId, projectUserId, questionId, voteValue, voteComment);
		this.$command(cmd, questionId.toString());
	}

	invokeSavePanelistVoteCommentCommandV1(workspaceId: number, surveyId: number, projectUserId: number, questionId: number, voteComment: string | null)
	{
		const cmd = new c.SavePanelistVoteCommentCommandV1(workspaceId, surveyId, projectUserId, questionId, voteComment);
		this.$command(cmd, questionId.toString());
	}

	invokeSavePanelVoteCommandV1(workspaceId: number, surveyId: number, questionId: number, voteValue: number | null, voteComment: string | null)
	{
		const cmd = new c.SavePanelVoteCommandV1(workspaceId, surveyId, questionId, voteValue, voteComment);
		this.$command(cmd, questionId.toString());
	}

	invokeSavePanelVoteCommentCommandV1(workspaceId: number, surveyId: number, questionId: number, comment: string | null)
	{
		const cmd = new c.SavePanelVoteCommentCommandV1(workspaceId, surveyId, questionId, comment);
		this.$command(cmd, questionId.toString());
	}
}
